// Clock-In "Just a category" (Jade, 2026-10-10): time logged to a category
// with no habit/task/to-do behind it ("30 min of Study"). It rides the same
// main-page plan as habits and tasks, as a plan item of kind "category", but
// it is never "done": the check button saves the session and leaves the
// category picked so another one can start straight away.
//
// The saved session deliberately has NO kind/refId — the same shape as a
// plain category clock-in — so the stats group it by its label (the category
// name) and the details panel shows Category / Date / Duration / Note
// without treating it as a deleted habit or task.

// Per device on purpose (no clarity_ prefix, so sync.js leaves it alone).
export const LAST_CATEGORY_KEY = "clarityClockInCategory";

export function categoryPlanItem(cat) {
  return {
    qid: `cat:${cat.id}`, kind: "category", id: cat.id, title: cat.title,
    color: cat.color || null, goalId: cat.id, dailyCount: 1,
  };
}

export const isCategoryItem = (it) => it?.kind === "category";

export const SESSION_TITLE_MAX = 60;

/** The focus session a finished "Just a category" run is saved as. Its label
 *  is the optional session title typed under the category name ("Chapter 3"),
 *  else the category name. */
export function categorySession({ item, minutes, nowMs, id }) {
  const title = String(item.sessionTitle || "").trim().slice(0, SESSION_TITLE_MAX);
  const mins = Math.max(0, Math.round(minutes || 0));
  const start = new Date(nowMs - mins * 60000);
  const pad = (n) => String(n).padStart(2, "0");
  return {
    id,
    date: `${start.getFullYear()}-${pad(start.getMonth() + 1)}-${pad(start.getDate())}`,
    minutes: mins,
    completedAt: new Date(nowMs).toISOString(),
    startedAt: start.toISOString(),
    label: title || item.title, categoryLabel: item.title, categoryId: item.id,
  };
}

/** The remembered category, if it still exists. */
export function rememberedCategory(categories, storage = globalThis.localStorage) {
  try {
    const id = storage?.getItem(LAST_CATEGORY_KEY);
    return (id && (categories || []).find(c => c.id === id)) || null;
  } catch { return null; }
}

export function rememberCategory(id, storage = globalThis.localStorage) {
  try {
    if (id) storage?.setItem(LAST_CATEGORY_KEY, id);
    else storage?.removeItem(LAST_CATEGORY_KEY);
  } catch { /* per-device convenience only */ }
}
